import { Button, Modal } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { bindActionCreators } from 'redux';
import { login, logout } from '../actions/loginAction';
import { addOrder, deleteOrder, updateOrder } from '../actions/orderAction';
import {
  updateBasicPickupTime,
  updateBranchDelayTime,
} from '../actions/pickupTimeAction';
import {
  websockConnected,
  websockDisconnected,
  websockDuplicated,
} from '../actions/websocketAction';
import Const from '../const';
import {
  getUseNotifyChat,
  getUseNotifyOrderEtc,
  getUseNotifyOrderNew,
} from '../lib/module';
import { formatDate, formatJSONDateToString } from './util/dateUtil';
import {addWaitingOrder} from "../actions/posAction";
import {getYToken, putYLog, Y_LOG_ACTION_CODE, yogiyoOrderComplete} from "../api/api";
import { modalStyle } from '../lib/util/codeUtil';

const wsReadyState = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};
const getWSReadyStateStr = (state) => {
  return state === 0
    ? 'CONNECTING'
    : state === 1
    ? 'OPEN'
    : state === 2
    ? 'CLOSING'
    : state === 3
    ? 'CLOSED'
    : '';
};

const sendWebSocketPing = () => {
  setInterval(() => {
    try {
      const ws = global.ws;
      if (undefined === ws || null === ws) {
        return;
      }

      if ('function' === typeof ws.send) {
        ws.send('P');
      }

      try {
        // putYLog({
        //   action: Y_LOG_ACTION_CODE.NN_WS_PING,
        //   code:null,
        //   data:{ readyState:global?.ws?.readyState },
        //   result:null,
        // });
      } catch (e) {}

    } catch (e) {}
  }, Const.websocketPingIntervalMS);
};
sendWebSocketPing();

class NNWebSocket extends Component {
  constructor(props) {
    super(props);
    this.url = `${Const.wsProtocol}://${Const.wsHost}:${Const.wsPort}${Const.wsPath}`;

    this.state = {
      appState: '',
      visible: false,
      message: '',
    };
  }

  componentDidMount() {
    this.initWS();
    this.wsTimecheckWSInterval = setInterval(() => {
      this.checkWS();
    }, 20000);
  }

  componentWillUnmount() {
    clearInterval(this.wsTimeInterval);
  }

  initWS = () => {
    if (global.ws != null) {
      global.ws.close();
      global.ws = null;
    }
    global.ws = new WebSocket(this.url);
    global.ws.onopen = () => {
      // connection opened
      global.ws.send('something'); // send a message
      try {
        // putYLog({
        //   action:Y_LOG_ACTION_CODE.NN_WS_ONOPEN,
        //   code:null,
        //   data:null,
        //   result:null,
        // });
      } catch (e) {}

      this.props.websockConnected();
    };
    global.ws.onmessage = async (e) => {
      // a message was received

      /* websocket SESSION_ID 저장 */
      const dataVal = e.data;

      if (
        typeof dataVal === 'string' &&
        4 < dataVal.length &&
        dataVal.substring(0, 4) === 'SID:'
      ) {
        const arr = dataVal.split('SID:');
        if (2 === arr.length) {
          global.ws.sessionId = arr[1];
        }
        return;
      }

      if (e.data == 'logged in from another location') {
        return;
      }
      let message = {};
      try {
        message = JSON.parse(e.data);
      } catch (error) {
        return;
      }
      let data = {};
      if (message.data instanceof Object) data = message.data;
      else data = JSON.parse(message.data);

      try {
        // putYLog({
        //   action:Y_LOG_ACTION_CODE.NN_WS_ONMESSAGE,
        //   code:null,
        //   data,
        //   result:null,
        // });
      } catch (e) {}


        // 채팅 메세지 / 지점수정 / 최소픽업시간변경 외에 주문 관련 메세지는 해당 가맹점 메세지 외에 전부 제외
      const messageTypeFilter = [
        'CHAT',
        'BRANCH_UPDATE',
        'BASIC_PICKUP_TIME_UPDATE',
      ];
      if (
        !messageTypeFilter.includes(message.messageType) &&
        data.frIdx !== this.props.loginReducer.loginInfo.idx
      )
        return;
      if (message.messageType == 'CHAT') {

        if (!isNaN(message.sendUserIdx) && 0 < message.sendUserIdx) {
          data.sendUserIdx = message.sendUserIdx;
        }

        let oppName = '';
        if (this.props.loginReducer.loginInfo.idx == message.data.member1) {
          oppName = message.data.member2Name;
        } else oppName = message.data.member1Name;

        if (
          !global.chatAprear &&
          !global.chatDetailAprear &&
          getUseNotifyChat()
        ) {
          //채팅중이 아닐때만 띄우기
          this.setState(
            {
              visible: true,
              message: '[' + oppName + '] ' + message.data.lastMessage,
            },
            () => this.messageAlert()
          );
        } else {
          //채팅창 활성화 시 해당 컴포넌트로 전송
          if (global.chatListener) global.chatListener(message.data);
          if (global.chatDetailListener)
            global.chatDetailListener(message.data);
        }
        // 주문취소(신규) 알림
      } else if (message.messageType === 'ORDER_NEW') {

        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        data.orderPayments = payments;
        data.waitingStatus = 0;
        if (
          this.props.orderReducer.orders.findIndex(
            (order) => order.idx === data.idx
          ) !== -1
        ) {
          // 배차 취소시 orderStatus가 바뀌기전 2인 상태로 옴
          // + 소켓으로 오는 데이터 Date 형식이 다른 api에서 쓰는 형식과 다른 형식으로 옴
          if (data.orderDate && data.orderDate.date)
            data.orderDate = formatJSONDateToString(data.orderDate);
          if (data.assignDate) data.assignDate = null;
          data.orderStatus = 1;
          this.props.updateOrder(data);
        } else {
          if (getUseNotifyOrderEtc()) {
            let audio = new Audio('1.wav');
            audio.volume = this.props.volume;
            audio.crossOrigin = 'anonymous';
            audio.play();
          }
          if (data.orderDate && data.orderDate.date)
            data.orderDate = formatJSONDateToString(data.orderDate);
          this.props.addOrder('NEW', data);
        }
      } else if (message.messageType === 'ORDER_ASSIGN') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);

        data.orderStatus = 2;
        if (
          this.props.orderReducer.orders.findIndex(
            (order) => order.idx === data.idx
          ) > -1
        )
          this.props.updateOrder(data);
        else this.props.addOrder('NEW', data);

        if (getUseNotifyOrderEtc()) {
          let audio = new Audio('4.wav');
          audio.volume = this.props.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }
      } else if (message.messageType === 'ORDER_PICIUP') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);
        if (data.pickupDate && data.pickupDate.date)
          data.pickupDate = formatJSONDateToString(data.pickupDate);

        this.props.updateOrder(data);

        if (getUseNotifyOrderEtc()) {
          let audio = new Audio('13.wav');
          audio.volume = this.props.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }
      } else if (message.messageType === 'ORDER_PICIUP_CANCEL') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);

        this.props.updateOrder(data);

        //TODO 관제에는 음성이 빠져있는데 가맹점에서 안내하는 음성인지 모르겠음.
        // 일단은 음원이 있어서 넣어놓음. 어떤 경우 음성안내 나가는건지 확정 필요.
        if (getUseNotifyOrderEtc()) {
          let audio = new Audio('8.wav');
          audio.volume = this.props.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }
      } else if (message.messageType === 'ORDER_COMPLETE') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);
        if (data.pickupDate && data.pickupDate.date)
          data.pickupDate = formatJSONDateToString(data.pickupDate);
        if (data.completeDate && data.completeDate.date)
          data.completeDate = formatJSONDateToString(data.completeDate);
        this.props.deleteOrder('NEW', data);
        this.props.addOrder('COMPLETE', data);

        if (getUseNotifyOrderEtc()) {
          let audio = new Audio('5.wav');
          audio.volume = this.props.volume;
          audio.crossOrigin = 'anonymous';
          audio.play();
        }

        if (
            data?.memo &&
            typeof data.memo === 'string' &&
            data.memo.startsWith('oma_')
        ) {
          // y연동 주문 완료처리
          try {
            const loginInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
            const yTokenRes = await getYToken({
              branchIdx: loginInfo?.branchIdx,
              frId: loginInfo?.id,
            });

            if (yTokenRes === null || yTokenRes?.value?.token === null || yTokenRes?.value?.token === undefined) return;

            const res = await yogiyoOrderComplete(data.memo, yTokenRes.value.token);
            if (res?.state !== 'CLOSED') return;
          } catch (e) {
            console.error('Error while y Order complete', e);
          }
        }

      } else if (message.messageType === 'ORDER_CANCEL') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (getUseNotifyOrderNew()) this.orderCancelAlert();

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);
        if (data.pickupDate && data.pickupDate.date)
          data.pickupDate = formatJSONDateToString(data.pickupDate);

        this.props.deleteOrder('NEW', data);
        this.props.addOrder('COMPLETE', data);
      } else if (message.messageType === 'ORDER_UPDATE') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate && data.orderDate.date)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate && data.assignDate.date)
          data.assignDate = formatJSONDateToString(data.assignDate);
        if (data.pickupDate && data.pickupDate.date)
          data.pickupDate = formatJSONDateToString(data.pickupDate);

        this.props.updateOrder(data);
      } else if (message.messageType === 'ORDER_RESTORE') {
        let payments = [...data.orderPayments];
        for (let i = 0; i < payments.length; i++) {
          const payment = payments[i];
          payment.updateDate = formatDate(
            formatJSONDateToString(payment.updateDate)
          );
        }

        if (data.orderDate)
          data.orderDate = formatJSONDateToString(data.orderDate);
        if (data.assignDate)
          data.assignDate = formatJSONDateToString(data.assignDate);
        if (data.pickupDate)
          data.pickupDate = formatJSONDateToString(data.pickupDate);
        data.completeDate = null;
        data.orderStatus = 3;

        this.props.deleteOrder('COMPLETE', data);
        this.props.addOrder('NEW', data);
      } else if (message.messageType === 'BRANCH_UPDATE') {
        const prevDeliveryData = reactLocalStorage.getObject(
          Const.appName + '#deliverydata'
        );
        const useEtcVoiceGuidance = getUseNotifyOrderEtc();
        const deliveryData = {
          ...data,
        };

        this.props.updateBranchDelayTime(deliveryData);

        reactLocalStorage.setObject(
          Const.appName + '#deliverydata',
          deliveryData
        );

        if (prevDeliveryData && prevDeliveryData.deliveryEnabled) {
          if (
            prevDeliveryData.deliveryEnabled !== deliveryData.deliveryEnabled &&
            !deliveryData.deliveryEnabled
          ) {
            Modal.info({
              title: '배송불가 알림',
              content: '배송불가 상태입니다.',
              ...modalStyle,
            });
            if (useEtcVoiceGuidance) {
              let audio = new Audio('9.wav');
              audio.volume = this.props.volume;
              audio.crossOrigin = 'anonymous';
              audio.play();
            }
          }
        }

        let flag = false;
        if (
          prevDeliveryData &&
          (prevDeliveryData.delayPickupTime ||
            prevDeliveryData.delayPickupTime === 0)
        ) {
          if (prevDeliveryData.delayPickupTime !== deliveryData.delayPickupTime)
            flag = true;
        }

        if (flag) {
          if (deliveryData.delayPickupTime === 0) {
            Modal.info({
              title: '지연시간 알림',
              content: `지연이 해제되었습니다.`,
              ...modalStyle,
            });
            if (useEtcVoiceGuidance) {
              global.speak('지연이 해제되었습니다.');
            }
          } else {
            let delayTime = 0;
            let prevDelayTime = 0;
            if (deliveryData.delayPickupTime)
              delayTime = deliveryData.delayPickupTime;
            if (prevDeliveryData.delayPickupTime)
              prevDelayTime = prevDeliveryData.delayPickupTime;
            if (delayTime !== 0) {
              Modal.info({
                title: '지연시간 알림',
                content:
                  delayTime < prevDelayTime
                    ? '지연이 감소되었습니다'
                    : '지연이 추가되었습니다.',
                ...modalStyle,
              });
              if (useEtcVoiceGuidance) {
                let audio = new Audio('10.wav');
                audio.volume = this.props.volume;
                audio.crossOrigin = 'anonymous';
                audio.play();
              }
            }
          }
        }
      } else if (message.messageType === 'BASIC_PICKUP_TIME_UPDATE') {
        reactLocalStorage.setObject(Const.appName + '#basicPickupTime', data);
        this.props.updateBasicPickupTime(data);
      }

      global.setProcListOrders &&
        global.setProcListOrders(this.props.orderReducer.orders);
    };
    global.ws.onerror = (e) => {
      // an error occurred

      try {
        // putYLog({
        //   action: Y_LOG_ACTION_CODE.NN_WS_ONERROR,
        //   code: e?.code,
        //   data: e,
        //   result: e?.message,
        // });
      } catch (e) {}
      };
    global.ws.onclose = (e) => {
      // connection closed
      try {
        // putYLog({
        //   action: Y_LOG_ACTION_CODE.NN_WS_ONCLOSE,
        //   code: e?.code,
        //   data: e,
        //   result: e?.reason,
        // });
      } catch (e) {
      }

      this.props.websockDisconnected();
    };

    global.ws.getSessionId = () => {
      return global.ws.sessionId;
    };
  };
  checkWS = () => {
    if (!this.props.loginReducer.isLogin) {
      return;
    }
    if (global.ws === null || typeof global.ws === 'undefined') {
      return;
    }
    if (this.props.websockInfo.isDuplicated) {
    }
    if (global.ws.readyState !== wsReadyState.OPEN) {
      // this.getOrderInfo();
    }
    if (global.ws.readyState === wsReadyState.CLOSED) {
      global.ws = null;
      this.initWS();
    }
  };

  messageAlert = () => {
    let audio = new Audio('7.wav');
    audio.volume = this.props.volume;
    audio.play();
  };
  orderCancelAlert = () => {
    setTimeout(() => {
      let audio = new Audio('14.wav');
      audio.crossOrigin = 'anonymous';
      audio.volume = this.props.volume;
      audio.play();
    }, 8000);
  };

  render() {
    return (
      <div>
        <Modal
          visible={this.state.visible}
          title="채팅알람"
          okText="확인"
          onOk={() => {
            this.setState({ visible: false });
          }}
          footer={[
            <Button
              key="ok"
              onClick={() => {
                this.setState({ visible: false });
              }}>
              확인
            </Button>,
          ]}
          destroyOnClose={true}>
          <div>{this.state.message}</div>
        </Modal>
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    loginReducer: state.loginReducer,
    websockInfo: state.websock,
    volume: state.posReducer.volume,
    orderReducer: state.orderReducer,
  };
};

let mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      logout,
      websockConnected,
      websockDisconnected,
      websockDuplicated,
      addOrder,
      deleteOrder,
      updateOrder,
      updateBasicPickupTime,
      updateBranchDelayTime,
    },
    dispatch
  );
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NNWebSocket)
);
